import React, { useState } from 'react';

function Hosting() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    domain: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // You can handle sending this data to your backend or a 3rd party tool
    console.log('Form submitted:', formData);
    window.location.href =
      'https://www.paypal.com/ncp/payment/YOUR_PAYMENT_LINK'; // Replace with your actual link
  };

  return (
    <section
      className="py-5"
      style={{ backgroundColor: '#f9f9f9', marginTop: '40px' }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <h1 className="fw-bold">Web Hosting Plan</h1>
          <p className="fs-5">
            Affordable and reliable hosting at just <strong>₹1199/year</strong>.
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card shadow p-4 mb-4">
              <h4 className="mb-3">Plan Includes:</h4>
              <ul className="list-unstyled fs-6">
                <li>✓ 99.9% Uptime Guarantee</li>
                <li>✓ 5 GB NVMe SSD Storage</li>
                <li>✓ Free SSL Certificate</li>
                <li>✓ 1 Website Hosting</li>
                <li>✓ cPanel Access</li>
              </ul>
            </div>

            <div className="card shadow p-4">
              <h4 className="mb-3">Enter Your Details</h4>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Full Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Preferred Domain Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="domain"
                    value={formData.domain}
                    onChange={handleChange}
                    placeholder="e.g. yourdomain.com"
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100 rounded-pill"
                  style={{ backgroundColor: '#375578' }}
                >
                  Proceed to Payment
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hosting;
